import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { isEmpty, startCase } from 'lodash'

import {
  COMPLIANCE_TASK_TYPE,
  COACHING_INBOX,
  COMPLIANCE_INBOX,
  READY_FOR_REVIEW,
  COMPLETED,
  IGNORED,
} from '@/reducers/tasks/tasks.constants'
import { Drawer } from '@/components/drawer/Drawer'
import { CopyButton } from '@/components/buttons/CopyButton'

import { TaskDrawer } from '../drawers/TaskDrawer'

export const Task = ({ inboxType, handleUpdateTask, fetchTasksWithFilters }) => {
  const location = useLocation()
  const { task } = useSelector((state) => state.tasks)
  const taskUrl = `${window.origin}${location.pathname}${location.search}`
  const isArchived = task?.status !== READY_FOR_REVIEW
  const dataTestId = `task-drawer-card-${task?.id}`

  const getTaskTitle = (taskType) => {
    if (!taskType) return ''
    if (taskType.startsWith('qa')) {
      return 'QA Task'
    }
    if (taskType === COMPLIANCE_TASK_TYPE) {
      return 'Exception'
    }
    return `${startCase(taskType)} Task`
  }

  return (
    <Drawer
      id={task?.id || 'empty-task'}
      wide
      title={
        <div className="flex-align-center medium-gap" data-testid={`${dataTestId}-drawer-title`}>
          {getTaskTitle(task?.type)}
          <CopyButton content={taskUrl} name="Link" />
        </div>
      }
    >
      {(handleClose) =>
        isEmpty(task) ? (
          <div>No task available.</div>
        ) : (
          <TaskDrawer
            fetchTasksWithFilters={fetchTasksWithFilters}
            commentsEnabled={[COACHING_INBOX, COMPLIANCE_INBOX].includes(inboxType)}
            primaryActionButtonText={
              isArchived
                ? 'Reopen'
                : inboxType === COACHING_INBOX
                  ? 'Send to Agent'
                  : 'Mark as Reviewed'
            }
            handlePrimaryAction={(taskId) => {
              if (isArchived) {
                handleUpdateTask(taskId, task.organization_id, READY_FOR_REVIEW, handleClose)
              } else {
                handleUpdateTask(taskId, task.organization_id, COMPLETED, handleClose)
              }
            }}
            secondaryActionButtonText={isArchived ? null : 'Mark as Dismissed'}
            handleSecondaryAction={
              isArchived
                ? null
                : (taskId) => {
                    handleUpdateTask(taskId, task.organization_id, IGNORED, handleClose)
                  }
            }
          />
        )
      }
    </Drawer>
  )
}
